import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2 text-red-500" }, "Заполните минимум 1 доп. услугу полностью", -1)
const _hoisted_2 = { class: "flex items-center justify-between mb-1" }
const _hoisted_3 = { class: "font-semibold mb-2" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_ctx.payload_state.additionalServices.length)
    ? (_openBlock(), _createBlock(_component_modal, {
        key: 0,
        class: "auto",
        title: "Заполните данные о доставке",
        loading: _ctx.isLoading,
        scrollable: "",
        "confirm-disabled": _ctx.isConfirmDisabled,
        onCancel: _ctx.emitCancel,
        onConfirm: _ctx.emitSubmitted
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.formClasses)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalServices, (service, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `a-s-${idx}`,
                class: "mb-2"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(service.type_name), 1),
                  _createElementVNode("div", _hoisted_4, [
                    (_ctx.isWriteOff(service))
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          class: "primary small text",
                          onClick: ($event: any) => (_ctx.addWriteOff(service)),
                          hint: "Создать списание",
                          "hint-color": "text-white"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_the_button, {
                      class: "red small text",
                      onClick: ($event: any) => (_ctx.deleteService(service.id)),
                      hint: "Удалить",
                      "hint-color": "text-white"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                (_ctx.isCanRenderCarrier(service))
                  ? (_openBlock(), _createBlock(_component_the_select, {
                      key: 0,
                      value: _ctx.payload_state.additionalServices[idx].carrierId,
                      "onUpdate:value": ($event: any) => ((_ctx.payload_state.additionalServices[idx].carrierId) = $event),
                      placeholder: "Поставщик",
                      loading: _ctx.data_state.is_loading,
                      options: _ctx.data_state.list,
                      failed: _ctx.data_state.is_failed,
                      "error-text": "При получении списка поставщиков произошла ошибка",
                      "infinite-scroll": "",
                      onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.pagination.current_page))),
                      onLoadmore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.pagination.current_page + 1))),
                      onSearch: _ctx.searchCarriers,
                      onOptionBySearch: _ctx.unshiftFindedCarrier
                    }, null, 8, ["value", "onUpdate:value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanRenderCarrier(service))
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 1,
                      class: "w-full mt-2",
                      placeholder: "Себестоимость за час",
                      value: _ctx.payload_state.additionalServices[idx].costPerHour,
                      "onUpdate:value": ($event: any) => ((_ctx.payload_state.additionalServices[idx].costPerHour) = $event)
                    }, null, 8, ["value", "onUpdate:value"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanRenderCarrier(service))
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 2,
                      class: "w-full mt-2",
                      placeholder: "Кол-во",
                      value: _ctx.payload_state.additionalServices[idx].value,
                      "onUpdate:value": ($event: any) => ((_ctx.payload_state.additionalServices[idx].value) = $event)
                    }, null, 8, ["value", "onUpdate:value"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanRenderCarrier(service))
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 3,
                      class: "w-full mt-2",
                      placeholder: "Общее затраченное время",
                      value: _ctx.payload_state.additionalServices[idx].duration,
                      "onUpdate:value": ($event: any) => ((_ctx.payload_state.additionalServices[idx].duration) = $event)
                    }, null, 8, ["value", "onUpdate:value"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 2)
        ]),
        _: 1
      }, 8, ["loading", "confirm-disabled", "onCancel", "onConfirm"]))
    : _createCommentVNode("", true)
}